import { useCallback, useEffect, useState } from 'react';
import * as service from './service';
var INITIAL_PRELIMINARY_SESSION = {
    id: undefined,
    paymentMethod: undefined,
};
export var usePreliminarySession = function (_a) {
    var onCartItemsRemoved = _a.onCartItemsRemoved;
    var _b = useState(INITIAL_PRELIMINARY_SESSION), preliminarySession = _b[0], setPreliminarySession = _b[1];
    useEffect(function () {
        service
            .getLastPreliminaryCheckoutSession()
            .then(function (data) {
            var _a, _b;
            if (data) {
                setPreliminarySession({
                    id: data.checkout_session_id,
                    paymentMethod: (_b = (_a = data.payment) === null || _a === void 0 ? void 0 : _a.payment_info) === null || _b === void 0 ? void 0 : _b.selected_payment_method,
                });
            }
        })
            .catch(function () {
            setPreliminarySession(INITIAL_PRELIMINARY_SESSION);
            // TODO: Consider triggering Sentry error.
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.error('[@browsing/overlays] Failed to fetch checkout preliminary session.');
            }
        });
    }, []);
    var cancelPreliminarySession = useCallback(function (id) {
        service
            .cancelPreliminarySession(id)
            .then(function () {
            setPreliminarySession(INITIAL_PRELIMINARY_SESSION);
            onCartItemsRemoved();
        })
            .catch(function () {
            setPreliminarySession(INITIAL_PRELIMINARY_SESSION);
            // TODO: Consider triggering Sentry error.
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.error('[@browsing/overlays] Failed to cancel checkout preliminary session.');
            }
        });
    }, [onCartItemsRemoved]);
    return { preliminarySession: preliminarySession, cancelPreliminarySession: cancelPreliminarySession };
};
